
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"27.384","height":"36.082"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Grupo 5783"}},[_c('g',{attrs:{"data-name":"Grupo 5777"}},[_c('path',{attrs:{"data-name":"Unión 283","d":"M.651 36.082a.65.65 0 01-.651-.65V.65A.65.65 0 01.651 0h16.482a.65.65 0 01.455.185l9.6 9.388a.649.649 0 01.2.465V35.431a.65.65 0 01-.651.65zm.65-1.3H26.08V10.723h-8.964a.65.65 0 01-.65-.651V1.299H1.297zM17.77 9.423h7.373L17.77 2.197z"}})]),_c('g',{attrs:{"data-name":"Grupo 5779"}},[_c('path',{attrs:{"data-name":"Unión 282","d":"M6.001 28.498a3.241 3.241 0 013.237-3.237 3.222 3.222 0 011.938.645v-7.508a.65.65 0 01.537-.64l9-1.593a.6.6 0 01.113-.011.652.652 0 01.418.152.652.652 0 01.232.5v10.1a3.241 3.241 0 01-3.237 3.237 3.24 3.24 0 01-3.237-3.237 3.241 3.241 0 013.237-3.237 3.22 3.22 0 011.938.646v-4.183l-7.7 1.365V28.501a3.241 3.241 0 01-3.238 3.237 3.241 3.241 0 01-3.238-3.24z"}})])])])
          )
        }
      }
    